<template>
  <svg width="100%" height="28px" style="display: block">
    <rect v-if="selectionRect"
      :x="selectionRect.x1String" y="0" :width="selectionRect.widthString" rx="2"
      ry="2" height="100%" fill="#49DB70" fill-opacity="0.1"/>
    <line v-if="selectionRect"
      :x1="selectionRect.x1String" y1="0"
      :x2="selectionRect.x1String" y2="100%" stroke="#49DB70"/>
    <line v-if="selectionRect"
      :x1="selectionRect.x2String" y1="0"
      :x2="selectionRect.x2String" y2="100%" stroke="#49DB70"/>
    <g v-for="(reseau, index) in reseaux" :key="index">
      <title>{{ reseau.labelHover }} ({{ reseau.startStringHover }} - {{
        reseau.endStringHover }})</title>
      <rect
        :x="reseau.x1String" y="0" :width="reseau.widthString" rx="2" ry="2"
        height="100%" stroke="#E43A45" stroke-width="2" fill="#E43A45"/>
      <text
        :x="reseau.xmilieuString" y="50%" dominant-baseline="central" text-anchor="middle"
        font-size="10" fill="white">{{ reseau.label }}</text>
      <text
        :x="reseau.x1String" y="50%" dominant-baseline="central" text-anchor="start"
        font-size="10" fill="white">&#xA0;{{ reseau.startString }}</text>
      <text
        :x="reseau.x2String" y="50%" dominant-baseline="central" text-anchor="end"
        font-size="10" fill="white">{{ reseau.endString }}&#xA0;</text>
    </g>
    <g v-for="vente in ventes" :key="vente.key">
      <title>{{ vente.labelHover }} {{ vente.tacite }} ({{ vente.startStringHover }} - {{
        vente.endStringHover }})</title>
      <rect
        :x="vente.x1String" y="0" :width="vente.widthString" rx="2" ry="2"
        height="100%" :stroke="aliasNiveauDispo.COULEUR_DISPO_INDISPONIBLE" stroke-width="2"
        :fill="aliasNiveauDispo.COULEUR_DISPO_INDISPONIBLE"/>
      <text
        :x="vente.xmilieuString" y="50%" dominant-baseline="central" text-anchor="middle"
        font-size="10" fill="white">{{ vente.label }} {{ vente.tacite }}</text>
      <text
        :x="vente.x1String" y="50%" dominant-baseline="central" text-anchor="start"
        font-size="10" fill="white">&#xA0;{{ vente.startString }}</text>
      <text
        :x="vente.x2String" y="50%" dominant-baseline="central" text-anchor="end"
        font-size="10" fill="white">{{ vente.endString }}&#xA0;</text>
    </g>>
  </svg>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import getRectangle from '@/services/catalogue/planningHelper';
import { INFINITE_DAY_AFF } from '@/configuration/general';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import decorateurRectangleFacesLc from '@/services/decorateur/decorateurRectangleFacesLc';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');

export default {
  props: ['data', 'index'],
  data() {
    return {
      aliasNiveauDispo: niveauDispo,
    };
  },
  computed: {
    ...VenteFacesLc.mapGetters(['criterePlanning']),
    selectionRect() {
      return getRectangle(
        this.criterePlanning,
        this.criterePlanning.selectedDateStart,
        this.criterePlanning.selectedDateEnd,
      );
    },
    ventes() {
      const ventesArray = [];
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateEnd;
      const filtered = this.data.affectations.filter(cmd =>
        dateStart <= moment(cmd.dateFin) && dateEnd >= moment(cmd.dateDebut));
      filtered.forEach(cmd => {
        const result = getRectangle(this.criterePlanning,
          moment(cmd.dateDebut),
          moment(cmd.dateFin));
        if (result !== null) {
          decorateurRectangleFacesLc(result, cmd, this.criterePlanning);
          ventesArray.push(result);
        }
      });
      return ventesArray;
    },
    reseaux() {
      if (this.ventes.length) return [];
      const affectArray = [];
      const affect = this.affectReseauxTableau();
      affect.forEach(aff => {
        if (!aff.dateFin) aff.dateFin = INFINITE_DAY_AFF;
        const result = getRectangle(this.criterePlanning,
          moment(aff.dateDebut, 'YYYYMMDD'),
          moment(aff.dateFin, 'YYYYMMDD'));
        if (result !== null) {
          decorateurRectangleFacesLc(result, aff, this.criterePlanning);
          affectArray.push(result);
        }
      });
      return affectArray;
    },
  },
  methods: {
    affectReseauxTableau() {
      const affectationsReseau = this.data.affectationsReseaux;
      if (affectationsReseau.length > 0) {
        let chevauchement = 0;
        let i;
        let j;
        const tabChevauchement = [];
        affectationsReseau[0].annonceur = affectationsReseau[0].resLibelle;
        tabChevauchement.push(affectationsReseau[0]);
        for (i = 0; i < affectationsReseau.length - 1; i += 1) {
          for (j = i + 1; j < affectationsReseau.length; j += 1) {
            if (affectationsReseau[j].dateDebut <= affectationsReseau[i].dateFin) {
              if (affectationsReseau[j].dateFin > affectationsReseau[i].dateFin) {
                tabChevauchement[chevauchement].dateFin = affectationsReseau[j].dateFin;
                i = j;
              }
              tabChevauchement[chevauchement].annonceur = 'Multi-réseau';
            } else {
              chevauchement += 1;
              i = j - 1;
              tabChevauchement.push(affectationsReseau[j]);
              break;
            }
          }
          if (j === affectationsReseau.length) {
            break;
          }
        }
        return tabChevauchement;
      }
      return [];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/recherche/planningSvg.vue